module.exports = __webpack_public_path__ + "img/electric-meter.dee8582.svg";